var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modelLink"},[_c('lh-router-link',{attrs:{"to":_vm.to,"target":"_blank"}},[_c('lh-button',{attrs:{"fontSize":_vm.fontSize,"color":"black","backgroundColor":"#F2F2F2","padding":_vm.padding}},[_c('img',{style:({width:_vm.imgWidth,height:_vm.imgWidth}),attrs:{"src":_vm.getFavicon(_vm.to)}}),_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }